/**
 * BitAdapterToggle.jsx
 *
 * TH "Bit adapters required" toggle. Thin wrapper over `ToggleCard` wired to
 * `DSCContext.toggles.bitAdapter`. Default OFF.
 *
 * Conditional availability (tracker #20): disabled until a rod thread is
 * selected — `computeBitAdapterThreadOptions` in the cascade reducer requires
 * a rod thread to derive the adapter-thread dropdown options. Without this
 * gate, toggling ON before rod thread is picked produces an empty bit-adapter
 * slot.
 *
 * NEW per brainstorm §A (locked 19 May 2026) — no legacy source exists.
 *
 * Citations:
 *  - Brainstorm §A "TH Bit Adapters toggle".
 *  - Plan §0 row `BitAdapterToggle.jsx`.
 *  - Plan §1.5: toggle default OFF, cascade preserves shank-adapter.
 *  - Tracker #20: conditional toggle availability.
 *
 * @module components/dsc/BitAdapterToggle
 * @since 2026-05-20 (Group E SP2 — NEW per brainstorm §A)
 */

import { useDSCToggle, useDSC } from '@contexts/DSCContext';
import ToggleCard from './ToggleCard';

export default function BitAdapterToggle() {
  const { value, setValue } = useDSCToggle('bitAdapter');
  const { state } = useDSC();
  const rodThread = state.selections?.rod?.thread;
  const hasRodThread = !!rodThread;

  return (
    <ToggleCard
      id="dsc-bit-adapter-toggle"
      label="Bit adapters required"
      helperText="Insert bit adapters between rods and bits"
      value={value}
      onChange={setValue}
      disabled={!hasRodThread}
      disabledReason="Select a rod thread first"
      dataTestid="bit-adapter-toggle"
    />
  );
}
